import {
  createTableColumn,
  Link,
  TableColumnDefinition,
} from "@fluentui/react-components";
import i18n from "i18next";
import React, { useState } from "react";
import { IAppUserDto } from "../../../Models/IAppUserDto";
import { CheckmarkRegular, DismissRegular } from "@fluentui/react-icons";

interface IUserColumnsProps {
  small: boolean;
  onSelectedUser(item: IAppUserDto): void;
}

export function UserColumns(props: IUserColumnsProps) {
  const [itemsToDelete, setItemsToDelete] = useState<string[]>([]);
  const [editUser, setEditUser] = useState<IAppUserDto>();

  const columns: TableColumnDefinition<IAppUserDto>[] = [];

  columns.push(
    createTableColumn<IAppUserDto>({
      columnId: "email",
      compare: (a, b) => {
        if (a.email && b.email) {
          return a.email.localeCompare(b.email);
        } else return 0;
      },
      renderHeaderCell: () => {
        return "Email";
      },
      renderCell: (item) => {
        return (
          <div>
            <Link
              onClick={() => {
                props.onSelectedUser(item);
              }}
            >
              {item.email}
            </Link>
            {item.emailConfirmed ? (
              <CheckmarkRegular style={{ color: "green" }} />
            ) : (
              <DismissRegular style={{ color: "red" }} />
            )}
          </div>
        );
      },
    }),
  );

  if (!props.small) {
    columns.push(
      createTableColumn<IAppUserDto>({
        columnId: "vorname",
        compare: (a, b) => {
          if (a.vorname && b.vorname) {
            return a.vorname.localeCompare(b.vorname);
          } else return 0;
        },
        renderHeaderCell: () => {
          return i18n.t<string>("firstName");
        },
        renderCell: (item) => {
          return item.vorname;
        },
      }),
    );
  }

  columns.push(
    createTableColumn<IAppUserDto>({
      columnId: "nachname",
      compare: (a, b) => {
        if (a.nachname && b.nachname) {
          return a.nachname.localeCompare(b.nachname);
        } else return 0;
      },
      renderHeaderCell: () => {
        return i18n.t<string>("lastName");
      },
      renderCell: (item) => {
        return item.nachname;
      },
    }),
    createTableColumn<IAppUserDto>({
      columnId: "firma",
      compare: (a, b) => {
        if (a.firma && b.firma) {
          return a.firma.localeCompare(b.firma);
        } else return 0;
      },
      renderHeaderCell: () => {
        return i18n.t<string>("company");
      },
      renderCell: (item) => {
        return item.firma;
      },
    }),
    createTableColumn<IAppUserDto>({
      columnId: "stadt",
      compare: (a, b) => {
        if (a.stadt && b.stadt) {
          return a.stadt.localeCompare(b.stadt);
        } else return 0;
      },
      renderHeaderCell: () => {
        return i18n.t<string>("city");
      },
      renderCell: (item) => {
        return item.stadt;
      },
    }),
  );
  if (!props.small) {
    columns.push(
      createTableColumn<IAppUserDto>({
        columnId: "registrationDate",
        compare: (a, b) => {
          if (a.registrationDate && b.registrationDate) {
            return a.registrationDate.localeCompare(b.registrationDate);
          } else return 0;
        },
        renderHeaderCell: () => {
          return i18n.t<string>("registrationDate");
        },
        renderCell: (item) => {
          return (
            <div>{new Date(item.registrationDate).toLocaleDateString()}</div>
          );
        },
      }),
      createTableColumn<IAppUserDto>({
        columnId: "lastLoginDate",
        compare: (a, b) => {
          if (a.lastLoginDate && b.lastLoginDate) {
            return a.lastLoginDate.localeCompare(b.lastLoginDate);
          } else return 0;
        },
        renderHeaderCell: () => {
          return i18n.t<string>("lastLoginDate");
        },
        renderCell: (item) => {
          return <div>{new Date(item.lastLoginDate).toLocaleDateString()}</div>;
        },
      }),
    );
  }
  return columns;
}
